import { CSSObject } from '@chakra-ui/react';

export const FooterRowContainer: CSSObject = {
  flexDir: 'row',
  bg: 'transparent',
  minH: '2',
  alignItems: 'center',
};
